// SVG geometry retained under the MIT license in LICENSE.txt.
import React from 'react';
import { SvgIcon } from '../primitives';
const PriorityHigh = React.forwardRef(function PriorityHigh(props, ref) {
    return <SvgIcon {...props} ref={ref}><><circle cx="12" cy="19" r="2"/><path d="M10 3h4v12h-4z"/></></SvgIcon>;
});
export default PriorityHigh;
